import React from "react";

// Track compared provider ids in localStorage
const KEY = "st_compare_ids";

export function useCompare() {
  const [ids, setIds] = React.useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  const persist = (arr) => {
    setIds(arr);
    localStorage.setItem(KEY, JSON.stringify(arr));
  };

  const toggle = (id) => {
    if (ids.includes(id)) persist(ids.filter((x) => x !== id));
    else if (ids.length < 4) persist([...ids, id]);
  };

  const clear = () => persist([]);

  const remove = (id) => persist(ids.filter((x) => x !== id));

  return { ids, toggle, clear, remove, count: ids.length };
}
